import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "as-match-item__header" }
const _hoisted_2 = { class: "as-match-item__league" }
const _hoisted_3 = { class: "as-match-item__time as-match-item__status--normal" }
const _hoisted_4 = { class: "as-match-item__body" }
const _hoisted_5 = { class: "as-match-item__team as-match-item__team-home as-team--home" }
const _hoisted_6 = { class: "as-scoreboard" }
const _hoisted_7 = { class: "as-match-item__team as-match-item__team-away as-team--away" }
const _hoisted_8 = { class: "as-match-item__footer" }
const _hoisted_9 = { class: "as-flag as-d-flex" }
const _hoisted_10 = { class: "as-flag__goal-scoring as-d-flex" }
const _hoisted_11 = { class: "as-flag__corner-ball as-d-flex" }
const _hoisted_12 = { class: "as-flag__yellow-card as-d-flex" }

import { computed } from "vue";
import { usecommonStore } from "~src/stores/CommonStore";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";
import SkeletonLoader from "~src/components/SkeletonLoader.vue";


const __default__ = {};

interface IProps {
  isHomePage?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'MatchItemSkeleton',
  props: {
    isHomePage: { type: Boolean, default: false }
  },
  setup(__props: any) {

const commonStore = usecommonStore();
const matchDetailStore = useMatchDetailStore();

const props = __props;

const siteName = computed(() => commonStore.getSiteName);
const screenWidth = computed(() => matchDetailStore.getScreenWidth);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["as-match-item", {
        'as-match-item-sm': screenWidth.value < 360,
      }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(SkeletonLoader, {
          width: "80px",
          height: "20px",
          line: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SkeletonLoader, {
          class: "as-icon-haflt as-icon-haflt-loading",
          width: "106px",
          height: "26px",
          line: 0,
          style: {
              marginTop: '-8px',
              borderBottomLeftRadius: '50%',
              borderBottomRightRadius: '50%',
            }
        })
      ]),
      _createVNode(SkeletonLoader, {
        width: "80px",
        height: "20px",
        line: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(SkeletonLoader, {
          width: "65px",
          height: "20px",
          line: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(SkeletonLoader, {
          width: "40px",
          height: "40px",
          line: 1,
          mode: "circle"
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(SkeletonLoader, {
          width: "65px",
          height: "20px",
          line: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(SkeletonLoader, {
            width: "40px",
            height: "16px",
            line: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(SkeletonLoader, {
            width: "40px",
            height: "16px",
            line: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(SkeletonLoader, {
            width: "40px",
            height: "16px",
            line: 1
          })
        ])
      ])
    ])
  ], 2))
}
}

})